import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=702dcb5d&scoped=true"
import script from "./EditPage.vue?vue&type=script&lang=ts"
export * from "./EditPage.vue?vue&type=script&lang=ts"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=702dcb5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702dcb5d",
  null
  
)

export default component.exports